import { useEffect } from "react";

/**
 * iOS Safari + PWA: cuando el teclado virtual aparece en un modal con
 * scroll interno, el input enfocado puede quedar tapado por el teclado.
 * Este hook escucha global focus events y mete un scrollIntoView con
 * pequeño delay (después de que el teclado se abre) para mantener el
 * input visible y dejar margen al footer del form.
 *
 * Sólo actúa en mobile (breakpoint sm o menor) y para inputs/textareas/
 * selects dentro del DOM (no aria-disabled).
 */
const isMobile = () =>
  typeof window !== "undefined" && window.matchMedia("(max-width: 640px)").matches;

export default function useIOSKeyboardScroll() {
  useEffect(() => {
    if (!isMobile()) return;
    const onFocus = (e) => {
      const el = e.target;
      if (!el || !el.tagName) return;
      const tag = el.tagName.toUpperCase();
      if (!["INPUT", "TEXTAREA", "SELECT"].includes(tag)) return;
      // Skip hidden / disabled
      if (el.disabled || el.readOnly) return;
      // Tipos no-text que no muestran keyboard
      const t = (el.getAttribute("type") || "").toLowerCase();
      if (["checkbox", "radio", "button", "submit", "file"].includes(t)) return;

      // Pequeño delay para que iOS abra el teclado y recalcule viewport.
      setTimeout(() => {
        try {
          el.scrollIntoView({ block: "center", behavior: "smooth" });
        } catch {}
      }, 250);
    };
    document.addEventListener("focusin", onFocus, true);
    return () => document.removeEventListener("focusin", onFocus, true);
  }, []);
}
